import { render } from "./LanguajeSelector.vue?vue&type=template&id=d34aae62&scoped=true"
import script from "./LanguajeSelector.vue?vue&type=script&lang=js"
export * from "./LanguajeSelector.vue?vue&type=script&lang=js"

import "./LanguajeSelector.vue?vue&type=style&index=0&id=d34aae62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d34aae62"]])

export default __exports__